import { Container, ContainerInterno } from "./styles";
import { spaik } from "../../assets";
interface IBotPreview {
  color: string;
}
export const BotPreview: React.FC<IBotPreview> = ({ color }) => {
  return (
    <Container color={color}>
      <ContainerInterno color={color}>
        <img width="80%" src={spaik} alt="Bot Icon" />
      </ContainerInterno>
    </Container>
  );
};
